<span
  class='cursor-info badge badge-pill d-flex align-items-center justify-content-center mr-3 '
  [class.bg-light]='theme === "light"'
  [class.text-grey]='theme === "light"'
  [class.text-muted]='theme === "light"'
  [class.bg-dark]='theme === "dark"'
  [class.text-white]='theme === "dark"'
  >{{extractInitialsFromName(fullName)}}
</span>
